import { toDate } from "common/utils/dates";
import { UserSubscriptionAction } from "common/types";

import { useCurrentDialog } from "client/common/hooks/stackables";
import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";

import { useUpdateSubscriptionMutation } from "../../hooks";
import { ClientSubscription } from "../../types";

export type SubscriptionSkipNextOrderDialogProps = {
  subscription: ClientSubscription;
};

const SubscriptionSkipNextOrderDialog = ({
  subscription,
}: SubscriptionSkipNextOrderDialogProps) => {
  const { close } = useCurrentDialog();
  const {
    mutate: updateSubscription,
    isLoading,
    error,
  } = useUpdateSubscriptionMutation(subscription.id, {
    onSuccess: close,
  });

  return (
    <ConfirmationDialog
      title="Confirm skipping next order"
      description={`If you skip this next order, the new order date will be scheduled for ${toDate(
        subscription.skip_order_date,
      )}`}
      denyText="No, keep order"
      confirmText="Yes, skip order"
      onConfirm={() => updateSubscription({ action: UserSubscriptionAction.Skip })}
      onDeny={close}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default SubscriptionSkipNextOrderDialog;
